import {
  createEntityAdapter,
  createSelector,
  type Comparer,
} from '@reduxjs/toolkit';

type EntityWithId = {
  id: string;
};

type CreateQueryEntitySelectorsParams<State, Entity extends EntityWithId> = {
  selectList: (state: State) => Entity[];
  sortComparer?: false | Comparer<Entity>;
};

export const createQueryEntitySelectors = <State, Entity extends EntityWithId>({
  selectList,
  sortComparer = false,
}: CreateQueryEntitySelectorsParams<State, Entity>) => {
  const adapter = createEntityAdapter<Entity, string>({
    selectId: (entity) => entity.id,
    sortComparer,
  });
  const initialState = adapter.getInitialState();

  const selectEntityState = createSelector([selectList], (entities) =>
    adapter.setAll(initialState, entities),
  );

  const selectors = adapter.getSelectors<State>(selectEntityState);

  return {
    selectAll: selectors.selectAll,
    selectEntities: selectors.selectEntities,
    selectIds: selectors.selectIds,
    selectTotal: selectors.selectTotal,
  };
};
